<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Desempenho dos Clientes</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
              v-b-tooltip.hover.bottom
              title="Filtros"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span
                v-if="countFilter > 0"
                class="badge badge-light"
              >{{countFilter}}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Desempenho dos clientes em relação a outros períodos</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6
                    v-if="pagination.TotalItems > 0"
                    class="m-0"
                  >{{pagination.TotalItems | number}} {{pagination.TotalItems > 1 ? " itens" : "item"}}</h6>
                  <div class="dropdown m-0">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : '' "
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader :small="true" :isLoading="loadingReport"></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelName }}
                    </th>
                    <th scope="col" class="border-0">Variação (%)</th>
                    <th scope="col" class="border-0">Variação (Qtd)</th>
                    <th scope="col" class="border-0">Valor transacionado (R$)</th>
                    <th scope="col" class="border-0">Total no mês atual</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(metrics, index) in listaMerchantMetrics"
                    :key="index"
                  >
                    <td></td>
                    <td class="text-left">
                      {{ metrics.Merchant.Name }}
                      <br />
                      <div
                        v-if="
                          metrics.PercentageRaiseBankSlip > 0 ||
                          metrics.QuantityRaiseBankSlip > 0 ||
                          metrics.QuantityTotalBankslip > 0
                        "
                      >
                        <br />
                        <span style="float: right">Boleto</span>
                      </div>
                      <div
                        v-if="
                          metrics.PercentageRaiseCreditCard > 0 ||
                          metrics.QuantityRaiseCreditCard > 0 ||
                          metrics.QuantityTotalCreditCard > 0
                        "
                      >
                        <br />
                        <span style="float: right">Cartão de crédito</span>
                      </div>
                      <div
                        v-if="
                          metrics.PercentageRaiseBitcoin > 0 ||
                          metrics.QuantityRaiseBitcoin > 0 ||
                          metrics.QuantityTotalBitcoin > 0
                        "
                      >
                        <br />
                        <span style="float: right">Criptomoedas</span>
                      </div>
                      <div	
                        v-if="	
                          metrics.PercentageRaisePix > 0 ||	
                          metrics.QuantityRaisePix > 0 ||	
                          metrics.QuantityTotalPix > 0	
                        "	
                      >	
                        <br />	
                        <span style="float: right">Pix</span>	
                      </div>
                      <br />	
                      <span style="float: right;font-weight:700">Total</span>
                    </td>
                    <td class="td-with-subs">
                      
                      <br /><br />
                      <div
                        v-if="
                          metrics.PercentageRaiseBankSlip > 0 ||
                          metrics.QuantityRaiseBankSlip > 0 ||
                          metrics.QuantityTotalBankslip > 0
                        "
                      >
                        <span
                          v-if="metrics.PercentageRaiseBankSlip >= 0"
                          style="display: inline"
                          class="stats-small__percentage stats-small__percentage--increase"
                          >{{
                            metrics.PercentageRaiseBankSlip | percentage
                          }}</span
                        >
                        <span
                          v-else
                          style="display: inline"
                          class="stats-small__percentage stats-small__percentage--decrease"
                          >{{
                            metrics.PercentageRaiseBankSlip | percentage
                          }}</span
                        >
                      </div>
                      <div
                        v-if="
                          metrics.PercentageRaiseCreditCard > 0 ||
                          metrics.QuantityRaiseCreditCard > 0 ||
                          metrics.QuantityTotalCreditCard > 0
                        "
                      >
                        <span
                          v-if="metrics.PercentageRaiseCreditCard >= 0"
                          style="display: inline"
                          class="stats-small__percentage stats-small__percentage--increase"
                          >{{
                            metrics.PercentageRaiseCreditCard | percentage
                          }}</span
                        >
                        <span
                          v-else
                          style="display: inline"
                          class="stats-small__percentage stats-small__percentage--decrease"
                          >{{
                            metrics.PercentageRaiseCreditCard | percentage
                          }}</span
                        >
                      </div>
                      <div
                        v-if="
                          metrics.PercentageRaiseBitcoin > 0 ||
                          metrics.QuantityRaiseBitcoin > 0 ||
                          metrics.QuantityTotalBitcoin > 0
                        "
                      >
                        <span
                          v-if="metrics.PercentageRaiseBitcoin >= 0"
                          style="display: inline"
                          class="stats-small__percentage stats-small__percentage--increase"
                          >{{
                            metrics.PercentageRaiseBitcoin | percentage
                          }}</span
                        >
                        <span
                          v-else
                          style="display: inline"
                          class="stats-small__percentage stats-small__percentage--decrease"
                          >{{
                            metrics.PercentageRaiseBitcoin | percentage
                          }}</span
                        >
                      </div>
                      <div
                        v-if="
                          metrics.PercentageRaiseDebitCard > 0 ||
                          metrics.QuantityRaiseDebitCard > 0 ||
                          metrics.QuantityTotalDebitCard > 0
                        "
                      >
                        <span
                          v-if="metrics.PercentageRaiseDebitCard >= 0"
                          style="display: inline"
                          class="stats-small__percentage stats-small__percentage--increase"
                          >{{
                            metrics.PercentageRaiseDebitCard | percentage
                          }}</span
                        >
                        <span
                          v-else
                          style="display: inline"
                          class="stats-small__percentage stats-small__percentage--decrease"
                          >{{
                            metrics.PercentageRaiseDebitCard | percentage
                          }}</span
                        >
                      </div>
                      <div
                        v-if="
                          metrics.PercentageRaisePix > 0 ||
                          metrics.QuantityRaisePix > 0 ||
                          metrics.QuantityTotalPix > 0
                        "
                      >
                        <span
                          v-if="metrics.PercentageRaisePix >= 0"
                          style="display: inline"
                          class="stats-small__percentage stats-small__percentage--increase"
                          >{{
                            metrics.PercentageRaisePix | percentage
                          }}</span
                        >
                        <span
                          v-else
                          style="display: inline"
                          class="stats-small__percentage stats-small__percentage--decrease"
                          >{{
                            metrics.PercentageRaisePix | percentage
                          }}</span
                        >
                      </div>
                      <span
                        v-if="metrics.PercentageRaise >= 0"
                        style="display: inline;font-weight:700"
                        class="stats-small__percentage stats-small__percentage--increase"
                        >{{ metrics.PercentageRaise | percentage }}</span
                      >
                      <span
                        v-else
                        style="display: inline;font-weight:700"
                        class="stats-small__percentage stats-small__percentage--decrease"
                        >{{ metrics.PercentageRaise | percentage }}</span
                      >
                    </td>
                    <td class="td-with-subs">
                     
                      <br />
                      <br />
                      <div
                        v-if="
                          metrics.PercentageRaiseBankSlip > 0 ||
                          metrics.QuantityRaiseBankSlip > 0 ||
                          metrics.QuantityTotalBankslip > 0
                        "
                      >
                        <span
                          v-if="metrics.QuantityRaiseBankSlip >= 0"
                          style="display: inline"
                          class="stats-small__percentage stats-small__percentage--increase"
                          >{{ metrics.QuantityRaiseBankSlip | number }}</span
                        >
                        <span
                          v-else
                          style="display: inline"
                          class="stats-small__percentage stats-small__percentage--decrease"
                          >{{ metrics.QuantityRaiseBankSlip | number }}</span
                        >
                      </div>
                      <div
                        v-if="
                          metrics.PercentageRaiseCreditCard > 0 ||
                          metrics.QuantityRaiseCreditCard > 0 ||
                          metrics.QuantityTotalCreditCard > 0
                        "
                      >
                        <span
                          v-if="metrics.QuantityRaiseCreditCard >= 0"
                          style="display: inline"
                          class="stats-small__percentage stats-small__percentage--increase"
                          >{{ metrics.QuantityRaiseCreditCard | number }}</span
                        >
                        <span
                          v-else
                          style="display: inline"
                          class="stats-small__percentage stats-small__percentage--decrease"
                          >{{ metrics.QuantityRaiseCreditCard | number }}</span
                        >
                      </div>
                      <div
                        v-if="
                          metrics.PercentageRaiseBitcoin > 0 ||
                          metrics.QuantityRaiseBitcoin > 0 ||
                          metrics.QuantityTotalBitcoin > 0
                        "
                      >
                        <span
                          v-if="metrics.QuantityRaiseBitcoin >= 0"
                          style="display: inline"
                          class="stats-small__percentage stats-small__percentage--increase"
                          >{{ metrics.QuantityRaiseBitcoin | number }}</span
                        >
                        <span
                          v-else
                          style="display: inline"
                          class="stats-small__percentage stats-small__percentage--decrease"
                          >{{ metrics.QuantityRaiseBitcoin | number }}</span
                        >
                      </div>
					  <div	
                        v-if="	
                          metrics.PercentageRaisePix > 0 ||	
                          metrics.QuantityRaisePix > 0 ||	
                          metrics.QuantityTotalPix > 0	
                        "	
                      >	
                        <span	
                          v-if="metrics.QuantityRaisePix >= 0"	
                          style="display: inline"	
                          class="stats-small__percentage stats-small__percentage--increase"	
                          >{{ metrics.QuantityRaisePix | number }}</span	
                        >	
                        <span	
                          v-else	
                          style="display: inline"	
                          class="stats-small__percentage stats-small__percentage--decrease"	
                          >{{ metrics.QuantityRaisePix | number }}</span	
                        >	
                      </div>
                       <span
                        v-if="metrics.QuantityRaise >= 0"
                        style="display: inline;font-weight:700"
                        class="stats-small__percentage stats-small__percentage--increase"
                        >{{ metrics.QuantityRaise | number }}</span
                      >
                      <span
                        v-else
                        style="display: inline;font-weight:700"
                        class="stats-small__percentage stats-small__percentage--decrease"
                        >{{ metrics.QuantityRaise | number }}</span
                      >
                    </td>
                    <td class="td-with-subs">
                     
                      <br />
                      <br />
                      <div
                      v-if="
                          metrics.PercentageRaiseBankslip > 0 ||
                          metrics.QuantityRaiseBankslip > 0 ||
                          metrics.QuantityTotalBankslip > 0
                        "
                      >
                        {{ metrics.AmountTotalBankslip | currency }}
                      </div>
                      <div
                        v-if="
                          metrics.PercentageRaiseCreditCard > 0 ||
                          metrics.QuantityRaiseCreditCard > 0 ||
                          metrics.QuantityTotalCreditCard > 0
                        "
                      >
                        {{ metrics.AmountTotalCreditCard | currency }}
                      </div>
                      <div
                        v-if="
                          metrics.PercentageRaiseBitcoin > 0 ||
                          metrics.QuantityRaiseBitcoin > 0 ||
                          metrics.QuantityTotalBitcoin > 0
                        "
                      >
                        {{ metrics.AmountTotalBitcoin | currency }}
                      </div>
                      <div
                        v-if="
                          metrics.PercentageRaisePix > 0 ||
                          metrics.QuantityRaisePix > 0 ||
                          metrics.QuantityTotalPix > 0
                        "
                      >
                        {{ metrics.AmountTotalPix | currency }}
                      </div>
                       <div style="font-weight:700">{{ metrics.AmountTotal | currency }}</div>
                    </td>
                    <td class="td-with-subs">
                      
                      <br /><br />
                      <span
                        v-if="
                          metrics.PercentageRaiseBankslip > 0 ||
                          metrics.QuantityRaiseBankslip > 0 ||
                          metrics.QuantityTotalBankslip > 0
                        "
                        >{{ metrics.QuantityTotalBankslip | number}}</span
                      >
                      <div
                        v-if="
                          metrics.PercentageRaiseCreditCard > 0 ||
                          metrics.QuantityRaiseCreditCard > 0 ||
                          metrics.QuantityTotalCreditCard > 0
                        "
                      >
                        {{ metrics.QuantityTotalCreditCard | number }}
                      </div>
                      <div
                        v-if="
                          metrics.PercentageRaiseBitcoin > 0 ||
                          metrics.QuantityRaiseBitcoin > 0 ||
                          metrics.QuantityTotalBitcoin > 0
                        "
                      >
                        {{ metrics.QuantityTotalBitcoin | number }}
                      </div>
                      <div
                        v-if="
                          metrics.PercentageRaisePix > 0 ||
                          metrics.QuantityRaisePix > 0 ||
                          metrics.QuantityTotalPix > 0
                        "
                      >
                        {{ metrics.QuantityTotalPix | number }}
                      </div>
                       <div style="font-weight:700">
                      {{ metrics.QuantityTotal | number }}
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      listaMerchantMetrics == undefined ||
                      listaMerchantMetrics == null ||
                      listaMerchantMetrics.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
export default {
  name: "merchant-metrics",
  data: function () {
    return {
      countFilter: 0,
      labelName: "Cliente",
      filter: {
        Name: null,
      },
      loadingList: false,
      loadingModal: false,
      loadingReport: false,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0,
      },
      listaMerchantMetrics: [],
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListMerchantMetrics();
    },
    "pagination.RowsPerPage": function () {
      this.ListMerchantMetrics();
    },
  },
  mounted() {
    this.ListMerchantMetrics();
  },
  methods: {
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListMerchantMetrics();
    },
    GetParamsData: function (deletePagination = false) {
      let data = {
        ...this.pagination,
        ...{
          "Object.Merchant.Name": this.filter.Name,
        },
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.RowsPerPage;
        delete data.PageNumber;
      }
      return data;
    },
    ListMerchantMetrics: function () {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      let data = this.GetParamsData();
      this.$store
        .dispatch("ListMerchantMetrics", { params: data })
        .then((response) => {
          this.listaMerchantMetrics = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            "Não foi possível listar os clientes",
            "danger",
            "Desempenho de clientes",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("ReportMerchantMetrics", { params: data })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Falha ao gerar relatório, tente novamente mais tarde.",
            "danger",
            "Geração de relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    ResetFilter: function () {
      this.filter = {
        Name: null,
      };
      this.ListMerchantMetrics();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/pages/merchantMetrics.vue